import React from 'react'
import { Container, Main, Title, Result, ExpandableItem, ExpandableContentItem } from './styles'
import { Radio } from '~/components/shared'
import { IUrineCultureTest } from '~/interfaces'
import { message } from '~/services'
import { transformDate } from '~/utils'

const UrineCultureDetails = ({ details }: { details?: IUrineCultureTest }): JSX.Element => (
  <>
    <ExpandableContentItem>
      <ExpandableItem>
        {`${message('laboratory.collection_method')}: `}
        <Result>{details?.sampleCollectionMethod}</Result>
      </ExpandableItem>
    </ExpandableContentItem>

    <ExpandableContentItem>
      <ExpandableItem>
        {`${message('laboratory.growth')}: `}
        <Result>{details?.organismGrowth}</Result>
      </ExpandableItem>
    </ExpandableContentItem>

    {details?.organismGrowth === 'POSITIVO' && (
      <ExpandableContentItem>
        <ExpandableItem>
          {`${message('laboratory.organism')}: `}
          <Result>{details?.organism?.join(', ')}</Result>
        </ExpandableItem>
      </ExpandableContentItem>
    )}
  </>
)

export interface UrineCultureItemProps {
  urineCulture: IUrineCultureTest
  isSelected: boolean
  setSelected: React.Dispatch<IUrineCultureTest>
}

export const UrineCultureItem = ({ urineCulture, isSelected, setSelected }: UrineCultureItemProps): JSX.Element => {
  return (
    <Container>
      <Main tabIndex={1} htmlFor={urineCulture.id} isOpen={isSelected} positiveResult={urineCulture.isAltered}>
        <Radio
          size={18}
          id={urineCulture.id}
          name="urineCultureSelected"
          checked={isSelected}
          onChange={() => setSelected(urineCulture)}
        />
        <Title>{transformDate({ date: urineCulture.startDate })}</Title>
      </Main>

      {isSelected && <UrineCultureDetails details={urineCulture} />}
    </Container>
  )
}
